const osanoTrigger = {
    init() {
        const triggers = document.querySelectorAll('.js-osano-trigger');
        triggers.forEach(trigger => {
            trigger.addEventListener('click', event => {
                event.preventDefault();
                Osano.cm.showDoNotSell();
                const closeButtonDialog = document.querySelector('.osano-cm-info-dialog .osano-cm-close');
                closeButtonDialog?.focus();
            });
        });
    }
};

window.addEventListener('load', event => {
    osanoTrigger.init();
});
